/* jshint esversion: 6 */
import React from 'react';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import SocialInputConfigWidget from 'app/components/EditorComponents/SocialInputConfigWidget.jsx';
import PropTypes from 'prop-types';
import { assetBase } from '@/lib/asset-base.ts';
import { ConfigureStep } from '@/shadcn/components/NewAutomation/ConfigureStep.tsx';
import {
    socialConfigureChange,
    socialConfigureSpec
} from '@/lib/social-input-configure.ts';

class FacebookPageConfigPanel extends React.Component {
    constructor(props) {
        super(props);

        this.onPostTypesClick = this.onPostTypesClick.bind(this);
        this.onPostStyleClick = this.onPostStyleClick.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);

        // post behavior
        this.nativeWithLinkRef = React.createRef();
        this.nativeOnlyRef = React.createRef();
        this.sharedLinkRef = React.createRef();
    }

    onPostTypesClick(e) {
        let selectedOption = parseInt(e.target.dataset.option),
            typeFilter = (this.props.input !== undefined && this.props.input !== null && this.props.input.attrs && this.props.input.attrs.typeFilter) ? this.props.input.attrs.typeFilter : null,
            event = {
                currentTarget: {
                    dataset: {
                        field: `${this.props.statePath}.attrs.typeFilter`
                    }
                },
                target: {
                    value: 0
                }
            },
            constants = this.props.app.config.constants;

        if (typeFilter) {
            event.target.value = typeFilter;
        }

        if (e.target.nodeName === "SELECT") {
            // remove the existing values first
            if (event.target.value & constants.INPUT_TYPE_FILTER_IMAGE) {
                event.target.value -= constants.INPUT_TYPE_FILTER_IMAGE;
            }
            if (event.target.value & constants.INPUT_TYPE_FILTER_VIDEO) {
                event.target.value -= constants.INPUT_TYPE_FILTER_VIDEO;
            }
            event.target.value += parseInt(e.target.value);
        } else {
            if (!e.target.checked && (event.target.value - selectedOption === 0)) {
                return;
            } else {
                if (e.target.checked) {
                    event.target.value += selectedOption;
                } else {
                    event.target.value -= selectedOption;
                }

                if (event.target.value === constants.INPUT_SOURCE_FILTER_FEED) {
                    if (!(event.target.value & constants.INPUT_TYPE_FILTER_IMAGE)) {
                        event.target.value += constants.INPUT_TYPE_FILTER_IMAGE;
                    }
                    if (!(event.target.value & constants.INPUT_TYPE_FILTER_VIDEO)) {
                        event.target.value += constants.INPUT_TYPE_FILTER_VIDEO;
                    }
                }

            }
        }

        this.props.changeHandler(event);
    }

    onPostStyleClick(e) {
        let selectedOption = parseInt(e.target.dataset.option),
            constants = this.props.app.config.constants,
            event = {
                currentTarget: {
                    dataset: {
                        field: `${this.props.statePath}.socialOverrides.postStyle`
                    }
                },
                target: {
                    value: ''
                }
            };

        switch (selectedOption) {
            case constants.SOC_OVRD_STYLE_BOTH:
                this.nativeOnlyRef.current.checked = false;
                this.sharedLinkRef.current.checked = false;
                break;

            case constants.SOC_OVRD_STYLE_MEDIA:
                this.nativeWithLinkRef.current.checked = false;
                this.sharedLinkRef.current.checked = false;
                break;

            case constants.SOC_OVRD_STYLE_LINK:
                this.nativeOnlyRef.current.checked = false;
                this.nativeWithLinkRef.current.checked = false;
                break;

            default:
                break;
        }

        event.target.value = selectedOption;
        this.props.changeHandler(event);

    }

    /*
     * The new-design configure step. The fields are the same ones the legacy
     * fieldsets below render, and they reach the same backing fields:
     *
     *   Post the following items:  attrs.typeFilter, via onPostTypesClick so the
     *                             bitmask arithmetic stays in one place.
     *   Feed Post Media:           the same field's image/video bits, same handler.
     *   Post photos & videos as:   socialOverrides.postStyle.
     *   Include text in posts:     socialOverrides.postText.
     *
     * The account chip replaces SocialInputConfigWidget, which is identity
     * display only.
     */
    onFieldChange(field, value) {
        socialConfigureChange(field, value, {
            statePath: this.props.statePath,
            onPostTypes: this.onPostTypesClick,
            onChange: this.props.changeHandler
        });
    }

    render() {
        if (this.props.tile) {
            return (
                <ConfigureStep
                    spec={socialConfigureSpec('facebook', this.props.input, this.props.app.config.constants)}
                    base={assetBase(this.props.app.config)}
                    onFieldChange={this.onFieldChange} />
            );
        }

        return this.renderLegacy();
    }

    renderLegacy() {
        let name = (this.props.input !== undefined && this.props.input !== null && this.props.input.name) ? this.props.input.name : '',
            socialOverrides = (this.props.input !== undefined && this.props.input !== null && this.props.input.socialOverrides) ? this.props.input.socialOverrides : null,
            constants = this.props.app.config.constants,
            typeFilter = (this.props.input !== undefined && this.props.input !== null && this.props.input.attrs && this.props.input.attrs.typeFilter) ? this.props.input.attrs.typeFilter : 0,
            feedFilterOptions = null;

        if (!(typeFilter & constants.INPUT_SOURCE_FILTER_REELS) && !(typeFilter & constants.INPUT_SOURCE_FILTER_STORIES)) {
            feedFilterOptions = (
                <div>
                    <div className="supplemental-title">Feed Post Media:</div>
                    <StyledSelect
                        options={[
                            { label: 'Images + Videos', value: (constants.INPUT_TYPE_FILTER_IMAGE + constants.INPUT_TYPE_FILTER_VIDEO) },
                            { label: 'Images', value: constants.INPUT_TYPE_FILTER_IMAGE },
                            { label: 'Videos', value: constants.INPUT_TYPE_FILTER_VIDEO }
                        ]}
                        value={() => {
                            if ((typeFilter & constants.INPUT_TYPE_FILTER_IMAGE) && (typeFilter & constants.INPUT_TYPE_FILTER_VIDEO)) {
                                return constants.INPUT_TYPE_FILTER_IMAGE + constants.INPUT_TYPE_FILTER_VIDEO;
                            } else if ((typeFilter & constants.INPUT_TYPE_FILTER_IMAGE) && !(typeFilter & constants.INPUT_TYPE_FILTER_VIDEO)) {
                                return constants.INPUT_TYPE_FILTER_IMAGE;
                            } else if (!(typeFilter & constants.INPUT_TYPE_FILTER_IMAGE) && (typeFilter & constants.INPUT_TYPE_FILTER_VIDEO)) {
                                return constants.INPUT_TYPE_FILTER_VIDEO;
                            }
                        }}
                        selectClass="large"
                        onChange={this.onPostTypesClick}/>
                </div>
            );
        }

        let socialOverrideFields = (
            <div>
                <fieldset>
                    <legend>Post the following items:</legend>
                    <div className="inline-checkbox-wrapper">
                        <div className="inline-checkbox stacked">
                            <input
                                id="ig-feed-posts"
                                type="checkbox"
                                checked={(typeFilter & constants.INPUT_SOURCE_FILTER_FEED) ? true : false}
                                onChange={this.onPostTypesClick}
                                data-option={constants.INPUT_SOURCE_FILTER_FEED} />
                            <label htmlFor="ig-feed-posts">Feed Posts</label>
                        </div>
                        <div className="inline-checkbox stacked">
                            <input
                                id="ig-reel-posts"
                                type="checkbox"
                                checked={(typeFilter & constants.INPUT_SOURCE_FILTER_REELS) ? true : false}
                                onChange={this.onPostTypesClick}
                                data-option={constants.INPUT_SOURCE_FILTER_REELS} />
                            <label htmlFor="ig-reel-posts">Reels</label>
                        </div>
                        <div className="inline-checkbox stacked">
                            <input
                                id="ig-story-posts"
                                type="checkbox"
                                checked={(typeFilter & constants.INPUT_SOURCE_FILTER_STORIES) ? true : false}
                                onChange={this.onPostTypesClick}
                                data-option={constants.INPUT_SOURCE_FILTER_STORIES} />
                            <label htmlFor="ig-story-posts">Stories</label>
                        </div>
                    </div>
                   {feedFilterOptions}
                </fieldset>
                <fieldset>
                    <legend>Post photos & videos as: <HelpButton which="fbInputNativeMedia" /></legend>
                    <div className="inline-checkbox-wrapper">
                        <div className="inline-checkbox stacked">
                            <input
                                id="ig-native-only"
                                type="radio"
                                ref={this.nativeOnlyRef}
                                checked={(socialOverrides && socialOverrides.postStyle !== undefined && socialOverrides.postStyle === constants.SOC_OVRD_STYLE_MEDIA) ? true : false}
                                onChange={this.onPostStyleClick}
                                data-option={constants.SOC_OVRD_STYLE_MEDIA} />
                            <label htmlFor="ig-native-only">Native Media</label>
                        </div>
                        <div className="inline-checkbox stacked">
                            <input
                                id="ig-native-link"
                                type="radio"
                                ref={this.nativeWithLinkRef}
                                checked={(socialOverrides && socialOverrides.postStyle !== undefined && socialOverrides.postStyle === constants.SOC_OVRD_STYLE_BOTH) ? true : false}
                                onChange={this.onPostStyleClick}
                                data-option={constants.SOC_OVRD_STYLE_BOTH} />
                            <label htmlFor="ig-native-link">Native Media + Link</label>
                        </div>
                        <div className="inline-checkbox stacked">
                            <input
                                id="ig-shared-link"
                                type="radio"
                                ref={this.sharedLinkRef}
                                checked={(socialOverrides && socialOverrides.postStyle !== undefined && socialOverrides.postStyle === constants.SOC_OVRD_STYLE_LINK) ? true : false}
                                onChange={this.onPostStyleClick}
                                data-option={constants.SOC_OVRD_STYLE_LINK} />
                            <label htmlFor="ig-shared-link">Shared Link</label>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Include text in posts: <HelpButton which="fbInputCaption" /></legend>
                    <StyledSelect
                        options={[
                            { value: constants.SOC_OVRD_TEXT_BOTH, label: 'Message + Hashtags' },
                            { value: constants.SOC_OVRD_TEXT_CAPTION, label: 'Message' },
                            { value: constants.SOC_OVRD_NONE, label: 'No Text' }
                        ]}
                        linkedField={this.props.statePath + ".socialOverrides.postText"}
                        value={(socialOverrides && socialOverrides.postText !== undefined) ? socialOverrides.postText : constants.SOC_OVRD_TEXT_BOTH}
                        selectClass="large"
                        onChange={this.props.changeHandler} />
                </fieldset>
            </div>
        );

        if (this.props.onlySocialOverrides !== undefined && this.props.onlySocialOverrides) {
            return socialOverrideFields;
        }

        let socialIdentifier = null
        if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
            socialIdentifier = (
                <SocialInputConfigWidget
                    psID={constants.POST_SVC_FACEBOOK}
                    {...this.props}/>
            );
        }

        return (
            <div className="editor-panel">
                {socialIdentifier}
                {this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED ? (
                    <fieldset>
                        <legend>Input Name <span className="required">*</span></legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="name" errors={state.errors} />
                                );
                            }} />
                        <UncontrolledTextInput
                            className="text-input medium"
                            placeholder="Add Facebook Page Name"
                            defaultValue={name}
                            onChange={this.props.changeHandler}
                            data-field={this.props.statePath + ".name"} />
                    </fieldset>
                ) : null}
                {socialOverrideFields}
                {this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED ? (
                    <InputBehaviorComponent
                        {...this.props}
                        input={this.props.input}
                        changeHandler={this.props.changeHandler}
                        statePath={this.props.statePath} />
                ) : null}
                {this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED ? this.props.replayPromo : null}
            </div>
        );
    }

};

FacebookPageConfigPanel.displayName = "FacebookPageConfigPanel";

FacebookPageConfigPanel.propTypes = {
    /** Renders the new-design configure step instead of the legacy fieldsets. */
    tile: PropTypes.bool
};

FacebookPageConfigPanel.defaultProps = {
    tile: false
};

export default FacebookPageConfigPanel;
